import "./sass/main.scss";
import "./js/main";
